import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Button } from './ui/button';

/**
 * システムコンテナコンポーネント
 * ゲームの保存や設定などのシステム機能を管理します
 */
const SystemContainer: React.FC = () => {
  const gameState = useSelector((state: RootState) => state);
  
  // 自動保存機能
  useEffect(() => {
    const saveInterval = setInterval(() => {
      // ローカルストレージに保存
      localStorage.setItem('dimensionRebirth_saveData', JSON.stringify(gameState));
      console.log('ゲームを自動保存しました');
    }, 30000); // 30秒ごとに保存
    
    return () => clearInterval(saveInterval);
  }, [gameState]);
  
  // 手動保存
  const handleSaveGame = () => {
    localStorage.setItem('dimensionRebirth_saveData', JSON.stringify(gameState));
    alert('ゲームを保存しました');
  };
  
  // セーブデータの削除
  const handleResetGame = () => {
    if (confirm('セーブデータをリセットしますか？この操作は元に戻せません。')) {
      localStorage.removeItem('dimensionRebirth_saveData');
      // ページをリロード
      window.location.reload();
    }
  };
  
  return (
    <div className="fixed bottom-0 right-0 p-4 flex space-x-2">
      <Button 
        variant="secondary"
        size="sm"
        onClick={handleSaveGame}
      >
        保存
      </Button>
      <Button 
        variant="destructive"
        size="sm"
        onClick={handleResetGame}
      >
        リセット
      </Button>
    </div>
  );
};

export default SystemContainer; 